import {
   UPLOAD_FILE_REQUEST,
   UPLOAD_FILE_FAILURE,
   UPLOAD_FILE_SUCCESS,
   PROFILE_PICOR_INSURANCE_ID_REQUEST,
   PROFILE_PICOR_INSURANCE_ID_SUCCESS,
   PROFILE_PICOR_INSURANCE_ID_FAILURE,
   PROFILE_PICTURE_INSURANCE_ID_REQUEST,
   PROFILE_PICTURE_INSURANCE_ID_SUCCESS,
   PROFILE_PICTURE_INSURANCE_ID_FAILURE
} from "constants/UploadFile"

export const onUploadMicroBiologyResultRequest = (formData, uploadInformation) => {
   return {
      type: UPLOAD_FILE_REQUEST,
      payload: {
         formData,
         uploadInformation
      }
   }
}


export const onUploadMicroBiologyResultSuccess = (payload) => {
   return {
      type: UPLOAD_FILE_SUCCESS,
      payload: payload
   }
}


export const onUploadMicroBiologyResultFailure = (errorMessage) => {
   return {
      type: UPLOAD_FILE_FAILURE,
      paylaod: errorMessage
   }
}


export const uploadProfilePicOrInsuranceIdRequest = (formData) => {
   return {
      type: PROFILE_PICTURE_INSURANCE_ID_REQUEST,
      payload: {
         formData
      }
   }
}


export const uploadProfilePicOrInsuranceIdSuccess = (payload) => {
   return {
      type: PROFILE_PICTURE_INSURANCE_ID_SUCCESS,
      payload: payload
   };
};


export const uploadProfilePicOrInsuranceIdRequestFailure = (errorMessage) => {
   return {
      type: PROFILE_PICTURE_INSURANCE_ID_FAILURE,
      paylaod: errorMessage
   }
}